module.exports = __webpack_public_path__ + "img/2024-07-01c_7.20551929.jpg";